import SEOTestPage from '../../components/SEOTestPage';
import { SEO_TESTS } from '../../data/seoTestsConfig';
export default function DuygusalTukenmislikTestiPage() {
  return <SEOTestPage testConfig={SEO_TESTS['duygusal-tukenmislik-testi']} />;
}
